export const SELLER_REFERRAL_PARAM = "vendedor"

export const SELLER_REFERRAL_COOKIE_NAME = "astra_seller_code"

export const SELLER_REFERRAL_LS_KEY = "seller_referral_code"

export const SELLER_REFERRAL_LS_CAPTURED_AT_KEY = "seller_referral_code_captured_at"

export const SELLER_REFERRAL_ATTRIBUTION_WINDOW_DAYS_DEFAULT = 30

export function getSellerReferralAttributionWindowDays(): number {
  const raw = process.env.SELLER_REFERRAL_ATTRIBUTION_WINDOW_DAYS?.trim()
  if (raw) {
    const n = Number(raw)
    if (Number.isFinite(n) && n > 0 && n <= 365) return Math.floor(n)
  }
  return SELLER_REFERRAL_ATTRIBUTION_WINDOW_DAYS_DEFAULT
}
